import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors, type ThemeColorValues } from '@tokens/colors.stylex';

// Dark = the default operator console. Ported from the locked prototype
// (.ai/domains/frontend/design/prototype/assets/styles.css → [data-theme="dark"]).
export const darkTheme = {
  x1sj0b7k: "x16020nm x1sj0b7k",
  $$css: true
};